export default __webpack_public_path__ + "static/surf-30c52fd660d79aa89d04d6481ef5b8a7.svg";